import useRouter from '@gef-ui/router-core/hooks/useRouter';
import PropTypes from 'prop-types';
import all from "ramda/es/all";
import isNilOrEmpty from "ramda-extension/es/isNilOrEmpty";
import React, { useCallback } from 'react';
import Button from '@gef-ui/components/atoms/Button/Button';
import Text, { typeConstants, weightConstants } from '@gef-ui/components/atoms/Text/Text';
import { Grid, GridCol } from '@gef-ui/components/organisms/Grid';
import { getMessage } from '@gef-ui/localization/messages';
import { getComingFromUrl, includeExcludedUrl, removeUserAndCompanyFromUrl, revokeDelegationCookies, revokeOriginalUserCookies } from '../../utils';
import { useDefaultDelegationsValue } from '../utils';
const COMPONENT_NAME = 'NoAccess';
const NoAccess = (inProps)=>{
    const props = useDefaultDelegationsValue({
        inProps,
        name: COMPONENT_NAME
    });
    const location = useRouter().useLocation();
    const { Wrapper = React.Fragment } = props;
    const { originalUser, representativeFor } = location.state;
    const handleLoginAsOriginalUser = useCallback(()=>{
        revokeDelegationCookies();
        revokeOriginalUserCookies();
        const comingUrl = removeUserAndCompanyFromUrl(getComingFromUrl());
        if (!includeExcludedUrl(comingUrl) && !isNilOrEmpty(comingUrl)) {
            window.location.href = comingUrl;
        } else {
            window.location.href = '/';
        }
    }, []);
    const noAccess = all(isNilOrEmpty)([
        originalUser,
        representativeFor
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Delegations"
    }, /*#__PURE__*/ React.createElement(Wrapper, {}, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, null, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 12,
        className: "Text-center"
    }, /*#__PURE__*/ React.createElement(Text, {
        className: "Delegations-error Text--smallTitle",
        elementParagraph: true,
        type: typeConstants.PRIMARY,
        weight: weightConstants.MEDIUM
    }, noAccess ? getMessage('common:noAccess') : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", null, getMessage('common:delegationNoAccessLogin', {
        login: representativeFor
    })), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement("div", null, getMessage('common:delegationNoAccessRedirect'))))), !noAccess && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 4
    }), /*#__PURE__*/ React.createElement(GridCol, {
        sizeXS: 4
    }, /*#__PURE__*/ React.createElement(Button, {
        primary: true,
        block: true,
        label: getMessage('common:ok'),
        onClick: handleLoginAsOriginalUser
    })))))));
};
NoAccess.propTypes = {
    Wrapper: PropTypes.any,
    location: PropTypes.shape({
        state: PropTypes.shape({
            originalUser: PropTypes.string,
            representativeFor: PropTypes.string
        })
    })
};
export default NoAccess;
